<template>
  <div class="basic-group-info mt-4">
    <p class="mt-2 mb-2">
      <span class="bold">Team Coordinator:</span>
      {{ coordinator_name }}
    </p>
    <b-form-group>
      <div v-if="parent !== 'Edit '">
        <b-col>
          <b-form-group>
            <b-input-group>
              <b-form-input
                v-model="filteredResults"
                placeholder="Type to Search"
              />
              <b-input-group-append>
                <b-btn
                  :disabled="!filteredResults"
                  @click="filteredResults = ''"
                  >Clear</b-btn
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-table
          v-cloak
          responsive
          :fields="searchResultsFields"
          :items="coordinators"
          :striped="true"
          :bordered="true"
          :hover="true"
          stacked="md"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filteredResults"
          @filtered="onFiltered"
        >
          <template slot="cell(first_name)" slot-scope="row">
            <b-link
              @click.stop="stopClick"
              :to="{ name: 'EditCoordinator', params: { id: row.item.uuid } }"
            >
              {{ row.item.first_name }} {{ row.item.middle_name }}
              {{ row.item.last_name }}
            </b-link>
            <br />
            <p class="small-date">country: {{ row.item.country }}</p>
            <p class="small-date">district: {{ row.item.region }}</p>
          </template>
          <template slot="cell(sex)" slot-scope="row">{{
            row.item.sex === "male" ? "M" : "F"
          }}</template>
          <template slot="cell(id)" slot-scope="row">
            <b-link class="add" @click.stop="setCoordinator(row.item)"
              >SET</b-link
            >
          </template>
        </b-table>
        <b-row>
          <b-col md="6" class="my-1">
            <b-pagination
              :total-rows="coordinators.length || 0"
              :per-page="perPage"
              v-model="currentPage"
              class="my-0"
            />
          </b-col>
        </b-row>
      </div>
    </b-form-group>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "TeamCoordinator",
  props: {
    parent: String,
  },
  data() {
    return {
      searchResultsFields: [
        { key: "first_name", label: "name", sortable: true },
        { key: "sex", label: "sex", sortable: true },
        { key: "id", label: "SET" },
      ],
      currentPage: 1,
      perPage: 3,
      filteredResults: null,
    };
  },
  methods: {
    ...mapActions({
      GET_COORDINATORS: "coordinators/GET_COORDINATORS",
    }),
    stopClick() {},
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    setCoordinator(item) {
      this.$store.commit("teams/team_coordinator", item.uuid);
      this.$store.commit(
        "teams/coordinator_name",
        `${item.first_name} ${item.middle_name} ${item.last_name}`
      );
    },
  },
  computed: {
    coordinators: {
      get() {
        return this.$store.state.coordinators.coordinators;
      },
    },
    team_coordinator: {
      get() {
        return this.$store.state.teams.team.team_coordinator;
      },
    },
    coordinator_name: {
      get() {
        return this.$store.state.teams.team.coordinator_name;
      },
    },
  },
  mounted() {
    this.GET_COORDINATORS();
  },
};
</script>

<style scoped>
.bold {
  font-weight: bold;
}
</style>
